import { render, staticRenderFns } from "./ProfessionalPanelV2026.vue?vue&type=template&id=3c078826&scoped=true"
import script from "./ProfessionalPanelV2026.vue?vue&type=script&lang=js"
export * from "./ProfessionalPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalPanelV2026.vue?vue&type=style&index=0&id=3c078826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c078826",
  null
  
)

export default component.exports